import { PIX_TYPES } from 'components/PaymentForm/PixPayments/PixWithdrawalForm';

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validateEmail = (email: string) =>
  emailRegex.exec(String(email).toLowerCase());

export const validatePixKey = (pixType: string, value?: string) => {
  if (!value) return { message: 'required' };

  const errorMaxLength = (ruleOption: number) => ({
    message: 'max_length',
    params: { ruleOption },
  });

  switch (pixType) {
    case PIX_TYPES.PHONE:
      if (value.length > 14) return errorMaxLength(14);
      break;
    case PIX_TYPES.EMAIL:
      if (!validateEmail(value)) return { message: 'incorrect_email' };
      if (value.length > 128) return errorMaxLength(128);
      break;
    case PIX_TYPES.EVP:
      if (value.length > 128) return errorMaxLength(128);
      break;
    default:
      return null;
  }
};
